import React, { useEffect } from 'react';
import Navbar from '../components/site/Navbar';
import Hero from '../components/site/Hero';
import SignalOrbSection from '../components/site/SignalOrbSection';
import ClientLogos from '../components/site/ClientLogos';
import Differentiators from '../components/site/Differentiators';
import Ticker from '../components/site/Ticker';
import Capabilities from '../components/site/Capabilities';
import PaidMedia from '../components/site/PaidMedia';
import OwnedMedia from '../components/site/OwnedMedia';
import EtechIntel from '../components/site/EtechIntel';
import DataIntel from '../components/site/DataIntel';
import Signals from '../components/site/Signals';
import IntentScoring from '../components/site/IntentScoring';
import Predictor from '../components/site/Predictor';
import Funnel from '../components/site/Funnel';
import Workflow from '../components/site/Workflow';
import AuditEngine from '../components/site/AuditEngine';
import Integrations from '../components/site/Integrations';
import Dashboard from '../components/site/Dashboard';
import CampaignPerf from '../components/site/CampaignPerf';
import QualifiedLeads from '../components/site/QualifiedLeads';
import CaseStudy from '../components/site/CaseStudy';
import Media from '../components/site/Media';
import WhyUs from '../components/site/WhyUs';
import CTA from '../components/site/CTA';
import Footer from '../components/site/Footer';
import SectionAnchor from '../components/site/SectionAnchor';
// Note: Pipeline (AI-Native Lead Gen Framework) intentionally removed per layout spec.
import useDocumentMeta from '../hooks/useDocumentMeta';

export default function Landing() {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://www.evolvebpm.com';
  useDocumentMeta({
    title: 'EvolveBPM — AI-powered B2B demand generation',
    description: 'Every buyer leaves a signal. EvolveBPM turns intent signals into qualified pipeline with Predictor.com, 46M contacts, and full-funnel B2B campaigns.',
    canonical: `${origin}/`,
  });
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add('in');
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        {/* ABOUT US */}
        <div id="about">
          <Hero />
          <SignalOrbSection />
          <ClientLogos />
        </div>

        {/* CORE CAPABILITIES — moved right after Trusted By */}
        <SectionAnchor id="capabilities" label="Core Capabilities" title="Every lever we pull, in one place." />
        <Capabilities />

        {/* PAID MEDIA */}
        <PaidMedia />

        {/* FULL FUNNEL DEMAND GENERATION — Delivered till date */}
        <SectionAnchor
          id="full-funnel"
          label="Full Funnel Demand Generation"
          title={<>Full-funnel demand generation. <span className="text-[#4ECDC4]">Delivered till date.</span></>}
        />
        <Funnel />

        <Ticker />

        {/* SERVICES — supporting media & intel */}
        <SectionAnchor id="services" label="Services" title="Media, data & intelligence." />
        <OwnedMedia />
        <EtechIntel />

        {/* OUR DATA COVERAGE */}
        <SectionAnchor id="data-coverage" label="Data Coverage" title="46M contacts. Real-time signal." />
        <DataIntel />

        {/* ABM SOLUTIONS — wraps ABM Platform, ABM Playbook, Signal Intelligence,
            Campaign Performance & Qualified Lead Register */}
        <SectionAnchor id="abm-solutions" label="ABM Solutions" title="Account-based, signal-driven, end-to-end." />
        <div id="abm-platform">
          {/* ABM Platform (previously "Solution Blueprint") */}
          <SectionAnchor id="blueprint" label="ABM Platform" title="Product, process, & platform." />
          <Predictor />
        </div>
        <IntentScoring />   {/* ABM Playbook */}
        <Signals />         {/* Signal Intelligence */}
        <CampaignPerf />    {/* Campaign Performance */}
        <QualifiedLeads />  {/* Qualified Lead Register */}

        <Workflow />

        {/* LEAD QUALITY → LIVE DASHBOARD */}
        <AuditEngine />
        <Dashboard />

        <Integrations />

        {/* CASE STUDIES */}
        <SectionAnchor id="case-studies" label="Case Studies" title="Real campaigns, real numbers." />
        <CaseStudy />

        {/* MEDIA */}
        <SectionAnchor id="media-anchor" label="Media" title="Press, awards & recognition." />
        <Media />

        {/* VALUE PROPOSITION — WhyUs + Why teams switch to us */}
        <section id="value-proposition">
          <WhyUs />
          <Differentiators />
        </section>

        {/* CONTACT */}
        <div id="contact">
          <CTA />
        </div>
      </main>
      <Footer />
    </div>
  );
}
